export default "__VITE_ASSET__Dpb6oT3O__"